import * as React from 'react';
import { useErrorLog } from '@core-front/error-provider';
const PropsChecker = (props) => {
    const { componentName, componentProps, defaultValueName, valueName, onChangeNames, onChangeAltNames, isComponentDisabled, children, } = props;
    const { log } = useErrorLog();
    const isInitial = React.useRef(true);
    const didWarnControlledToUncontrolled = React.useRef(false);
    const didWarnUncontrolledToControlled = React.useRef(false);
    const checkHasOnChange = () => {
        const onChangeNamesArray = Array.isArray(onChangeNames) ? onChangeNames : [onChangeNames];
        const onChangeAltNamesArray = Array.isArray(onChangeAltNames) ? onChangeAltNames : (onChangeAltNames ? [onChangeAltNames] : []);
        return onChangeNamesArray.every((onChangeName) => !!componentProps[onChangeName])
            || onChangeAltNamesArray && onChangeAltNamesArray.length > 0 && onChangeAltNamesArray.every((onChangeName) => !!componentProps[onChangeName]);
    };
    const hasOnChange = checkHasOnChange();
    const checkIsControlled = () => {
        const isDefined = typeof componentProps[valueName] !== 'undefined';
        if (isComponentDisabled) {
            return isDefined;
        }
        return hasOnChange && isDefined;
    };
    const newIsControlled = checkIsControlled();
    const isControlledRef = React.useRef(newIsControlled);
    React.useEffect(() => {
        function hasValuePropWithoutOnChangeProp() {
            return typeof componentProps[valueName] !== 'undefined' && !hasOnChange;
        }
        function formattedNames(names) {
            if (Array.isArray(names)) {
                return names.join(', ');
            }
            return names;
        }
        if (isInitial.current && hasValuePropWithoutOnChangeProp() && !isComponentDisabled) {
            log(`You provided a "${valueName}" prop without an "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} handler in "${componentName}" component. ` +
                `If the state is handled outside component, set "${formattedNames(onChangeNames)}"${onChangeAltNames ? ' or "' + formattedNames(onChangeAltNames) + '"' : ''} prop. Otherwise use "${defaultValueName}" prop.`);
            isInitial.current = false;
        }
    }, [componentName, componentProps, defaultValueName, hasOnChange, isComponentDisabled, onChangeAltNames, onChangeNames, valueName, log]);
    React.useEffect(() => {
        if (!isControlledRef.current && newIsControlled && !didWarnUncontrolledToControlled.current) {
            log(`The "${componentName}" component is changing from uncontrolled to be controlled. ` +
                `This is likely caused by the "${valueName}" changing from undefined to ` +
                'a defined value, which should not happen.');
            didWarnUncontrolledToControlled.current = true;
        }
        if (isControlledRef.current && !newIsControlled && !didWarnControlledToUncontrolled.current) {
            log(`The "${componentName}" component is changing from controlled to be uncontrolled. ` +
                `This is likely caused by the "${valueName}" changing from a defined to ` +
                'undefined value, which should not happen.');
            didWarnControlledToUncontrolled.current = true;
        }
        isControlledRef.current = newIsControlled;
    }, [componentProps, componentName, didWarnUncontrolledToControlled, didWarnControlledToUncontrolled, newIsControlled, valueName, log]);
    return (React.createElement(React.Fragment, null, children));
};
export default PropsChecker;
